export default __webpack_public_path__ + "static/media/Sequel100Black-45.02ab319b.ttf";